var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_3371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0436 1.14746H2.95665C1.73202 1.14746 0.739258 2.06324 0.739258 3.19292V12.2728C0.739258 13.4024 1.73202 14.3182 2.95665 14.3182H14.0436C15.2682 14.3182 16.261 13.4024 16.261 12.2728V3.19292C16.261 2.06324 15.2682 1.14746 14.0436 1.14746Z",
    stroke: "#7A808B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4271 10.6015C5.10027 10.6015 3.11003 12.7689 2.28076 13.8526C2.34986 13.8526 2.571 13.9291 2.90271 14.2351C3.23442 14.5411 3.73198 14.7451 3.9393 14.8088H10.5734C12.6466 14.8088 13.8906 14.6176 15.3418 13.4701C16.5027 12.5522 16.793 11.0477 16.793 10.4103C16.3783 9.26284 14.9271 7.73291 13.6832 7.73291C12.6002 7.73291 11.3403 8.98336 10.3655 10.2061C9.73471 10.9973 8.33547 11.0431 7.32392 10.737C7.04588 10.6528 6.74524 10.6015 6.4271 10.6015Z",
    fill: "#7A808B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97649 6.20277C6.12147 6.20277 7.04966 5.34655 7.04966 4.29035C7.04966 3.23415 6.12147 2.37793 4.97649 2.37793C3.83151 2.37793 2.90332 3.23415 2.90332 4.29035C2.90332 5.34655 3.83151 6.20277 4.97649 6.20277Z",
    fill: "#7A808B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_3371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.00f235fe375c6d32e7e07ce9062da5f7.svg";
export { ForwardRef as ReactComponent };